import { models } from "types/api/viewModels.ts";

export const mergeComplexityScoresBySku = (
	previousScores: Record<string, number>,
	scoreEntries: ReadonlyArray<readonly [string, number]>
): Record<string, number> => {
	const mergedScores = { ...previousScores };
	for (const [sku, score] of scoreEntries) {
		mergedScores[sku] = score;
	}
	return mergedScores;
};

export const getPreferredCqLineItem = (
	primaryLineItem?: models["CqModLineItemViewModel"],
	fallbackLineItem?: models["CqModLineItemViewModel"]
): models["CqModLineItemViewModel"] | undefined => {
	const primaryModsCount = primaryLineItem?.cqMods?.length ?? 0;
	const fallbackModsCount = fallbackLineItem?.cqMods?.length ?? 0;

	return primaryModsCount >= fallbackModsCount ? (primaryLineItem ?? fallbackLineItem) : fallbackLineItem;
};
